import React, {Component} from 'react';
import ReactDOM from "react-dom";

class Footer extends Component {

    render() {

        return (
            <div>
                <div className="section white">
                    <div className="container p-40">
                        <div className="row mb0 p-20">
                            <div className="col s12 m6 offset-m3 center-align mobile-center">
                                <img className="circle" src="static/disrupt-logo-square.jpg" alt="Fownders Icon Logo" height={80}/>
                                <p className="f-22 black-text">We are on a mission to transform the island of Puerto Rico and create a digital economy that fuels the next global innovation hub.</p>
                            </div>
                            <div className="col s3 m1 offset-m4 center-align">
                                <a href="https://www.youtube.com/channel/UCGjKvj2LQRcy3nY9txF0Mmw" target="_blank"><i className="fa fa-youtube-play fa-lg brand-text" aria-hidden="true"/></a>
                            </div>
                            <div className="col s3 m1 center-align">
                                <a href="https://www.instagram.com/disruptu/" target="_blank"><i className="fa fa-instagram fa-lg brand-text" aria-hidden="true"/></a>
                            </div>
                            <div className="col s3 m1 center-align">
                                <a href="https://www.facebook.com/groups/393586217781286/" target="_blank"><i className="fa fa-facebook-square fa-lg brand-text" aria-hidden="true"/></a>
                            </div>
                            <div className="col s3 m1 center-align">
                                <a href="https://twitter.com/disruptpodcast" target="_blank"><i className="fa fa-twitter fa-lg brand-text" aria-hidden="true"/></a>
                            </div>
                        
                        </div>
                    </div>
                </div>
                <div className="section black">
                    <div className="container p-20">
                        <div className="row mb0">
                            <div className="col s12 center-align">
                                <a className="f-14 white-text">© Copyright 2018 Disrupt LLC. All Rights Reserved.</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js